export default "__VITE_ASSET__4f668171__"